<template>
    <v-container>
    <v-row>
      <v-col cols="12" xl="8" lg="12" class="py-0">
        <urun-navigasyon />
      </v-col>
      <v-col cols="12" xl="8" lg="12" class="pt-5">
        <slot></slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UrunNavigasyon from "./UrunNavigasyon.vue";
import UrunlerService from "@/services/UrunlerService.js";
import Vue from "vue"
Vue.prototype.$UrunlerService = UrunlerService
export default {
    name: "UrunAreasLayout",
    components: {
        UrunNavigasyon
    }
}
</script>

<style>

</style>